module.exports = __webpack_public_path__ + "static/img/lxwm2x-51ivQMbM.95dd9b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/lxwm2x-51ivQMbM.png
// module id = ImJY
// module chunks = 16